export const playStoreLink = 'https://play.google.com/store/apps/details?id=com.codeyoung.studentapp&hl=en_IN';
export const appStoreLink = 'https://apps.apple.com/in/app/codeyoung-afterschool/id6475965042'